import React from 'react';
import validate from '../validate';
import plus from "../../../../assets/images/plus-circle2.svg";
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import {
    getProductById,
    getProduct,
    addQuotationProducts,
    dateFormat,
    clearSingleProduct,
    getBulkProducts,
    getGroupDiscount,
    displayCurrency,
    setProduct,
    addQuotationMergeProducts,
    editQuotationMergeProducts,
    getAllUnits,
} from "../../../../actions";
import { editGroupProduct } from '../services/servics';
import { Typeahead } from 'react-bootstrap-typeahead';
import { toast } from 'react-toastify';
import QuillEditor from '../../../../Components/EditorQuill';

const renderField = ({ input, placeholder, maxLength, defaultValue, type, readOnly, meta: { touched, error } }) => (
    <div>
        <label></label>
        <div>
            <input {...input} placeholder={placeholder} type={type} className="form-control" maxLength={maxLength}
                defaultValue={defaultValue}
                readOnly={readOnly} />
            {touched && error && <p className="require">{error}</p>}
        </div>
    </div>
);

const renderSelectField = ({ input, meta: { touched, error }, children }) => (
    <div>
        <div>
            <select {...input} className='form-control form-select mt-4'>
                {children}
            </select>
            {touched && error && <p className="require">{error}</p>}
        </div>
    </div>
)


class MergeProductForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            quantity: 0,
            discount: 0,
            productId: 0,
            popup: this.props.show,
            changed: false,
            unitCost: 0,
            items: [],
            total: 0,
            groupId: this.props.groupId,
            singleProduct: this.props.singleProduct,
            disabled: true,
            dataObj: '',
            unit: ''
        }
        this.myRef = React.createRef();
        this.popupRef = React.createRef();
        this.customerChange = this.customerChange.bind(this);
        this.inputChange = this.inputChange.bind(this);
        this.getQuantity = this.getQuantity.bind(this);
        this.getDiscount = this.getDiscount.bind(this);
        this.addGroupProduct = this.addGroupProduct.bind(this);
        this.clearSingleProductTrigger = this.clearSingleProductTrigger.bind(this);
        this.changeHandler = this.changeHandler.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getUnitCost = this.getUnitCost.bind(this);
        this.scrollToDiv = this.scrollToDiv.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    scrollToDiv = () => {
        // window.scrollTo(0, window.pageYOffset + 100);
        if (this.props.scrolled) {
            const div = document.getElementById('table-bluee');
            if (div !== null) {
                document.getElementById('table-bluee').scrollIntoView({ behavior: 'smooth', block: "start" });
            }
        } else {
            window.scroll({
                top: window.pageYOffset + 100,
                left: 0,
                behavior: 'smooth'
            });
        }
    }
    getUnitCost(e) {
        const unitCost = Number(e.target.value) || 0;
        const quantity = Number(document.querySelector('input[name="Quantity"]')?.value) || 0;
        const discount = Number(document.querySelector('input[name="discount"]')?.value) || 0
        const discountAmount = (unitCost * quantity * discount) / 100;
        console.log('getUnitCost:', { unitCost, quantity, discount, total: (unitCost * quantity) - discountAmount });
        this.setState({
            unitCost,
            total: (unitCost * quantity) - discountAmount
        });
    }
    getQuantity(e) {
        console.log('getQuantity:', document.querySelector('input[name="unitCost"]')?.value);
        const quantity = Number(e.target.value) || 0;
        // Get the latest unitCost from the form field or state
        const unitCost = Number(document.querySelector('input[name="unitCost"]')?.value) || Number(this.state.unitCost) || 0;
        const discount = Number(document.querySelector('input[name="discount"]')?.value) || 0;
        const discountAmount = (unitCost * quantity * discount) / 100;
        this.setState({
            quantity,
            total: (unitCost * quantity) - discountAmount
        });
    }
    getDiscount(e) {
        const discount = Number(e.target.value) || 0;
        const unitCost = Number(document.querySelector('input[name="unitCost"]')?.value) || Number(this.state.unitCost) || 0;
        const quantity = Number(document.querySelector('input[name="Quantity"]')?.value) || Number(this.state.quantity) || 0;
        const discountAmount = (unitCost * quantity * discount) / 100;
        this.setState({
            discount,
            total: (unitCost * quantity) - discountAmount
        });
    }
    customerChange(e) {
        this.setState({
            total: 0,
            // quantity: 0,
            // discount: 0,
        })
        this.props.reset();
        this.state.items?.map((item) => {
            if (e[0] === (`${item.productName} - ${item.articleId}`)) {
                this.props.dispatch(getProductById(item?.productId));
            }
        });
    }
    inputChange(text) {
        const ele = document.getElementById("async-example");
        if (ele !== null) {
            ele.style.transform = "translate3d(0px, -310px, 0px)";
            ele.style.height = "300px";
        }
        this.props.dispatch(getBulkProducts(text));
    }
    changeHandler() {
        this.props.reset();
        setProduct({})
        this.setState({
            changed: true,
            // total: 0
        })
    }
    componentDidUpdate(prevProps) {
        if (prevProps.productDetails !== this.props.productDetails) {
            const totalUnitCost = this.getTotalUnitCost(this.props.productDetails?.productDetails);
            const productName = this.props.productDetails?.productDetails[0].productName;
            console.log('totalUnitCost:', totalUnitCost);
                this.setState({ unitCost: totalUnitCost });
            if (this.props.str === "edit") {
                this.setState({
                    total: totalUnitCost,
                    dataObj:  this.props.productDetails?.workSpace ? productName : ""
                })
            }
        }
        if (prevProps.groupMergeProductsSuccess !== this.props.groupMergeProductsSuccess) {
            this.setState({
                groupMergeProductsSuccess: this.props.groupMergeProductsSuccess,
                disabled: true,
                total: 0,
                discount: 0,
                unitCost: 0,
                changed: false
            });
            this.props.getList();
            toast(this.props.groupMergeProductsSuccess.data);
            // dispatch(reset("RowForm"));
            const { initialValues } = this.props;
            initialValues.articleId = "";
            initialValues.unitName = "";
            initialValues.unitId = "";
            initialValues.currentPrice = "";
            initialValues.effectivePrice = "";
            this.props.dispatch(clearSingleProduct());
            this.props.reset();
            this.props.getAmounts();
            this.props.onHide();
            //clear typehead
            // document.getElementsByClassName("rbt-close")[0].click();
        } if (prevProps.bulkProducts !== this.props.bulkProducts) {
            this.setState({
                items: this.props.bulkProducts.content,
            });
        } if (prevProps.singleProduct !== this.props.singleProduct) {
            const { quantity, changed, discount } = this.state;
            const { initialValues, str } = this.props;
            if (str === "edit") {
                let qua = quantity === 0 ? initialValues.Quantity : quantity;
                let date1 = new Date();
                let oldDate = dateFormat(initialValues?.effectiveOnDate);
                let currentDate = dateFormat(date1);
                let checkDate = currentDate < oldDate;
                let price;
                if (str === "edit" && !changed) {
                    price = initialValues?.unitCost;
                } else {
                    price = checkDate ? initialValues?.currentPrice : initialValues?.effectivePrice
                }
                let discount1 = (price * Number(discount !== 0 ? discount : initialValues?.discount * qua)) / 100;
                this.setState({
                    total: (price * qua) - discount1
                })
            }
        }
    }
    handleClickOutside(e) {
        if (this.props.show && this.popupRef.current && !this.popupRef.current.contains(e.target)) {
            const { initialValues, reset, onHide } = this.props;
            this.setState({
                total: 0,
                quantity: 0,
                discount: 0,
                changed: false,
                dataObj: ""
            });
            initialValues.articleId = "";
            initialValues.unitName = "";
            initialValues.unitId = "";
            initialValues.currentPrice = "";
            initialValues.effectivePrice = "";
            reset();
            onHide();
        }
    }

    componentDidMount() {
        this.props.dispatch(getBulkProducts(""));
        this.props.dispatch(getAllUnits());
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    async addGroupProduct(formData) {
        const { data } = this.props;
        this.scrollToDiv();
        if (this.props.str === "edit") {
            if (!formData.Quantity) {
                throw new SubmissionError({
                    Quantity: 'Please fill the field *',
                })
            }
            // Use the add API for edit with the new payload structure
            let submitData = {
                workSpaceGroupProductId: this.props.productDetails?.productDetails[0]?.workSpaceGroupProductId,
                workSpaceProductName: this.state.dataObj,
                quantity: Number(formData.Quantity),
                unitId: formData.unitId,
                discount: Number(formData.discount),
                totalPrice: formData.unitCost
            };
            this.setState({
                disabled: false
            });
            this.props.dispatch(editQuotationMergeProducts(submitData));
        } else {
            if (this.state.dataObj && this.state.dataObj.trim() !== '') {
                const { initialValues } = this.props;
                let date1 = new Date();
                let oldDate = dateFormat(initialValues?.effectiveOnDate);
                let currentDate = dateFormat(date1);
                let checkDate = currentDate < oldDate;
                let price = checkDate ? initialValues?.currentPrice : initialValues?.effectivePrice;
                let data = {
                    "groupId": this.props.groupId,
                    "quantity": Number(formData.Quantity),
                    "unitId": Number(formData.unitId),
                    "discount": Number(formData.discount),
                    "totalPrice": formData.unitCost,
                    "unitPrice": formData.unitCost,
                    "workSpace" : true,
                    "workSpaceProductName": this.state.dataObj,
                }
                this.setState({
                    disabled: false
                })
                // document.getElementsByClassName("rbt-close")[0].click();
                this.props.dispatch(addQuotationMergeProducts(data, this.props.groupId));
            } else {
                toast("Enter Product Name")
            }
        }
    }
    clearSingleProductTrigger() {
        this.props.dispatch(clearSingleProduct());
    }

    handleChange(value) {
        this.setState({ dataObj: value });
    }

    getTotalUnitCost(productDetails) {
        console.log('productDetails:', productDetails);
        if (!Array.isArray(productDetails) || productDetails.length === 0) return 0;
        // If workSpace is true, return the API value directly
        if (productDetails?.workSpace) {
            return Number(productDetails[0].totalCost) || 0;
        }
        if (productDetails.length === 1) {
            return Number(productDetails[0].totalCost) || 0;
        }
        let total = 0;
        productDetails.forEach(product => {
            total += Number(product.totalCost) || 0;
        });
        return total;
    }

    render() {
        const { handleSubmit, show, onHide, reset, initialValues, str, data, productDetails } = this.props;
        const { total, disabled, changed } = this.state;
        let date1 = new Date();
        let oldDate = dateFormat(initialValues?.effectiveOnDate);
        let currentDate = dateFormat(date1);
        let checkDate = currentDate < oldDate;
        console.log(productDetails);


        return (
            <>
                <button onClick={() => {
                    reset();
                    this.setState({
                        total: 0,
                        popup: true,
                        quantity: "",
                        discount: "",
                        changed: false,
                        dataObj: ""
                    })
                    initialValues.articleId = "";
                    initialValues.unitName = "";
                    initialValues.unitId = "";
                    initialValues.currentPrice = "";
                    initialValues.effectivePrice = "";
                    this.clearSingleProductTrigger();
                }} className="group_product_btn" style={{ display: "none" }} >
                    <img src={plus} alt="" />
                    Add Product
                </button>
                {show ? <div
                    ref={this.popupRef}
                    className='mini-popup product_pop'
                    show={show}
                    id="mini_pop"
                    onHide={() => {
                        this.setState({
                            total: 0,
                            quantity: 0,
                            discount: 0,
                            changed: false,
                            dataObj: ""
                        })
                        initialValues.articleId = "";
                        initialValues.unitName = "";
                        initialValues.unitId = "";
                        initialValues.currentPrice = "";
                        initialValues.effectivePrice = "";
                        reset();
                        onHide();
                    }}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered >
                    <div className="modal-staff-here main">
                        <form onSubmit={handleSubmit(this.addGroupProduct)}>
                            <Row className="modal-row" >
                                <Col md={1} >
                                    <i class="fas fa-arrow-left" style={{ marginTop: "20px" }} onClick={() => {
                                        this.setState({
                                            popup: false,
                                            total: 0,
                                            quantity: 0,
                                            discount: 0,
                                            changed: false,
                                            dataObj: ""
                                        })
                                        initialValues.articleId = "";
                                        initialValues.unitName = "";
                                        initialValues.unitId = "";
                                        initialValues.currentPrice = "";
                                        initialValues.effectivePrice = "";
                                        reset();
                                        onHide();
                                    }}></i>
                                </Col>
                                <Col md={11} style={{ marginLeft: "-70px" }}>
                                    {/* <label className="form-control-placeholder" htmlFor="productName">Product Name <span>*</span></label> */}
                                    {/* <Field
                                        name="productName"
                                        type="text"
                                        component={renderField}
                                        placeholder="Enter Product Name"
                                        maxLength="100"
                                    /> */}
                                    <QuillEditor value={this.state.dataObj} onEditorChange={this.handleChange} />
                                </Col>
                                {/* <Col md={1}>
                                    <img src={back} alt="" onClick={onHide} className="close_img" />
                                </Col> */}
                                <Col md={1} style={{ marginLeft: "40px" }}>
                                    <label class="form-control-placeholder" for="name" >Qty <span>*</span></label>
                                    <Field
                                        name="Quantity"
                                        type="text"
                                        component={renderField}
                                        onChange={this.getQuantity}
                                        maxLength="8"
                                    />
                                </Col>
                                <Col md={1}>
                                    <label class="form-control-placeholder" for="name" >Dis</label>
                                    <Field
                                        name="discount"
                                        type="text"
                                        component={renderField}
                                        // readOnly={true}
                                        onChange={this.getDiscount}
                                        defaultValue="0"
                                        maxLength="4"
                                    />
                                </Col>
                                <Col md={1}>
                                    <label class="form-control-placeholder" for="name" >  Unit Cost </label>
                                        <Field
                                            name="unitCost"
                                            type="text"
                                            component={renderField}
                                        onChange={this.getUnitCost}
                                            // readOnly={true}
                                        />
                                </Col>
                                <Col md={1}>
                                    <div className='add_product_new'>
                                        <div>
                                            <p>Total Cost</p>
                                            <h3 style={{ textAlign: "right" }}>
                                                {this.state.total ? this.state.total.toFixed(2) : "0.00"}
                                            </h3>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <label class="form-control-placeholder" for="name" >Unit Name</label>
                                    <Field name="unitId" component={renderSelectField} className='form-control form-select mt-4' >
                                        <option value="" disabled={true} hidden={true}> </option>
                                        {this.props.units_list && this.props.units_list.length > 0 ? this.props.units_list.map((unit, i) => (
                                            <option value={unit?.unitId} key={i}>{unit?.unitName}</option>)) : ""}
                                    </Field>
                                    <div className="triangle-bottom"></div>
                                </Col>
                                <Field
                                    name="productId"
                                    type="hidden"
                                    component={renderField}
                                />
                                <Col md={2} style={{ marginTop: "4px" }}>
                                    {disabled ? <button type="submit" className="modal-btn sub-modal-btn" style={{ width: "130%" }}>
                                        {str === "merge" ? "Merge" : "Update"}  Product
                                    </button> : <button type="button" className="modal-btn sub-modal-btn" style={{ width: "130%" }}>Loading....</button>}
                                </Col>
                                <Col md={5}></Col>

                            </Row>
                        </form>
                    </div>
                </div> : null}
            </>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let item = state.product.singleProduct;
    let productItem = getProduct();
    let newItem = Object.keys(productItem).length !== 0 ? productItem : {};
    let data = {
        'articleId': newItem?.articleId,
        'productName': newItem.productName,
        'Quantity': newItem.quantity || localStorage.getItem("quantity"),
        'discount': newItem.discount,
        'unitName': newItem?.unit,
        'unitId': newItem?.unitId,
        'productId': newItem?.productId,
        "unitCost": newItem?.unitCost,
        'currentPrice': newItem?.unitCost,
        "effectivePrice": newItem?.unitCost,
        'totalCost': newItem?.totalCost,
        "actualCost": newItem?.actualCost
    };

    let initValues = item !== null ?
        {
            'articleId': item?.articleId,
            'unitName': item?.unitName,
            'unitId': item?.unitId,
            'productId': item?.productId,
            'currentPrice': item?.currentPrice,
            'effectivePrice': item?.effectivePrice,
            'totalStock': item?.totalStock,
            'Quantity': productItem?.quantity || localStorage.getItem("quantity"),
            "actualCost": item?.actualPrice
        } : data;

    // Accept str from ownProps
    const { str } = ownProps;

    if (item !== null) {
        initValues.discount = getGroupDiscount();
    }

    // If not edit mode, always set Quantity and discount to empty string
    if (str !== "edit") {
        initValues.Quantity = "";
        initValues.discount = "";
    } else {
    // fallback to previous logic for edit
        if (initValues?.Quantity) {
            initValues.Quantity = productItem?.quantity || localStorage.getItem("quantity");
        } else {
            initValues.Quantity = productItem?.quantity || localStorage.getItem("quantity");
        }
    }

    // Calculate totalUnitCost from productDetails if available
    let totalUnitCost = 0;
    let unitCost = 0;
    let discount = 0;
    const productDetails = ownProps.productDetails;
    if (Array.isArray(productDetails?.productDetails) && productDetails?.productDetails?.length > 0) {
        if (productDetails?.workSpace) {
            unitCost = Number(productDetails?.productDetails[0].unitCost);
            totalUnitCost = Number(productDetails?.productDetails[0].totalCost);
            discount = Number(productDetails?.productDetails[0].discount);
        } else {
            totalUnitCost = productDetails?.productDetails?.reduce((sum, product) => sum + (Number(product.totalCost) || 0), 0);
        }
    }

    initValues.unitCost = productDetails?.workSpace ? unitCost : totalUnitCost;
    initValues.discount = productDetails?.workSpace ? discount : productDetails?.discount;

    return {
        initialValues: initValues,
        bulkProducts: state.product.bulkProducts,
        products_list: state.product.products_list,
        singleProduct: state.product.singleProduct,
        productPage: state.qutation.productPage,
        page: state.product.page,
        groupMergeProductsSuccess: state.qutation.groupMergeProductsSuccess,
        units_list: state.unit.units_list,
    }
}

const MergeProduct = reduxForm({
    form: "MergeProductForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    validate
})(MergeProductForm);

export default connect(mapStateToProps)(MergeProduct);

